import { useEffect, useRef } from 'react'
import { acquireChatSocket, releaseChatSocket } from '../services/chatSocket'

const EVENTS = [
  'message:new',
  'message:edit',
  'message:delete',
  'reply:new',
  'reply:edit',
  'reply:delete',
  'message:like',
  'message:unlike',
  'room:update',
  'room:membership',
  'room:delete',
  'typing',
  'typing:stop',
]

// Subscribe to people-chat socket events for as long as the caller is mounted.
export function useChatEvents(onEvent) {
  const ref = useRef(onEvent)
  ref.current = onEvent

  useEffect(() => {
    const socket = acquireChatSocket()
    const pairs = EVENTS.map((name) => {
      const handler = (payload) => ref.current(name, payload || {})
      socket.on(name, handler)
      return [name, handler]
    })
    return () => {
      pairs.forEach(([name, handler]) => socket.off(name, handler))
      releaseChatSocket()
    }
  }, [])
}
